import { Flex, FlexProps } from '@grupoboticario/flora-react'
import { useMemo } from 'react'
import { ProductTag } from 'src/components/atoms'
import { ProductTagService } from 'src/service'

export type ProductTagsProps = {
  tags: string[]
} & Omit<FlexProps, 'children' | 'as' | 'gap'>

export function ProductTags({ tags, ...flexProps }: ProductTagsProps) {
  const sortedTags = useMemo(() => ProductTagService.sortByPriority(tags), [tags])

  if (!tags.length) {
    return null
  }

  return (
    <Flex
      {...flexProps}
      as="ul"
      gap="$2"
    >
      {sortedTags.map((tag) => (
        <ProductTag
          key={tag}
          as="li"
          tag={tag}
        />
      ))}
    </Flex>
  )
}
